/**
 * 热搜
 */
const selling = () => import(/* webpackChunkName: "module-community" */ "@/views/hotSearch");
const selectIntustry = () =>
  import(/* webpackChunkName: "module-community" */ "@/views/hotSearch/selectIntustry");

export default [
  {
    path: "/hot/selling/:type",
    name: "selling",
    component: selling,
    meta: { id: 10144, keepAlive: true },
  },
  {
    path: "/hot/selectIntustry/:id",
    name: "selectIntustry",
    component: selectIntustry,
  },
];
